import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FEATURE_FLAGS, usePartnerFeatureFlag } from 'support/helpers/featureFlags/featureFlags';
import { isStaging } from 'support/helpers/generic/generic';

type PartnerFeatureFlagGuardProps = {
  featureFlags: Array<FEATURE_FLAGS>;
  to: string;
  children: React.ReactNode;
};
export const PartnerFeatureFlagGuard = ({ featureFlags, to, children }: PartnerFeatureFlagGuardProps) => {
  const navigate = useNavigate();
  const { enabled, isLoading } = usePartnerFeatureFlag(featureFlags);
  useEffect(() => {
    if (isStaging()) {
      return;
    }
    if (!isLoading && !enabled) {
      navigate(to, { replace: true });
    }
  }, [enabled, isLoading, navigate, to]);

  if (enabled || isStaging()) {
    return <>{children}</>;
  }
  return null;
};
